import { render, staticRenderFns } from "./indexed_desindexed.vue?vue&type=template&id=76224e0b&"
import script from "./indexed_desindexed.vue?vue&type=script&lang=js&"
export * from "./indexed_desindexed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports